export default __webpack_public_path__ + "static/media/ronneby-kommun.c41425b1.svg";